if (!customElements.get('smallsmore-button-color-picker')) {
  customElements.define('smallsmore-button-color-picker', class SmallsmoreButtonColorPicker extends HTMLElement {
    connectedCallback() {
      this.selectedLabel = this.querySelector('[data-smallsmore-button-color-selected]');
      this.addEventListener('change', this.handleChange);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleChange);
    }

    handleChange = (event) => {
      const input = event.target.closest('input[name="properties[Buttons]"]');
      if (!input || !this.selectedLabel) return;
      this.selectedLabel.textContent = input.value;
    };
  });
}
